interface MailProps {
  className?: string;
}

const Mail = ({ className }: MailProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="98"
      height="91"
      viewBox="0 0 98 91"
      fill="none"
      className={className}
    >
      <circle cx="49.5" cy="45.2012" r="45" fill="#4BD4FF" />
      <path
        d="M7.625 37.8698C7.625 37.0938 7.9854 36.3617 8.60046 35.8885L47.6005 5.88011C48.4992 5.18858 49.7508 5.18858 50.6495 5.88011L89.6495 35.8885C90.2646 36.3617 90.625 37.0938 90.625 37.8698V79.2279C90.625 82.8178 87.7149 85.7279 84.125 85.7279H14.125C10.5351 85.7279 7.625 82.8178 7.625 79.2279V37.8698Z"
        fill="white"
        stroke="#9898A9"
      />
      <g filter="url(#filter0_d_325_331)">
        <rect
          x="15.823"
          y="12.7817"
          width="66.3449"
          height="51.6711"
          rx="3"
          fill="white"
        />
        <rect
          x="16.573"
          y="13.5317"
          width="64.8449"
          height="50.1711"
          rx="2.25"
          stroke="#0071F5"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M65.6951 45.1519H32.2966"
        stroke="#0071F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.6951 51.6426H32.2966"
        stroke="#0071F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.8008 58.1328L37.1902 58.1328"
        stroke="#0071F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#filter1_d_325_331)">
        <circle cx="49.4022" cy="30.6593" r="7.95813" fill="#FFFAE9" />
        <circle
          cx="49.4022"
          cy="30.6593"
          r="7.20813"
          stroke="#0071F5"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M46.219 31.2211L47.9042 33.0936L52.5855 28.2251"
        stroke="#0071F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_325_331"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="7"
        y="36"
        width="85"
        height="51"
      >
        <path
          d="M7.125 36.3252H91.125V80.2278C91.125 83.5415 88.4387 86.2278 85.125 86.2278H13.125C9.81129 86.2278 7.125 83.5415 7.125 80.2278V36.3252Z"
          fill="#E1E4ED"
        />
      </mask>
      <g mask="url(#mask0_325_331)">
        <path
          d="M7.875 80.2276V38.1486C7.875 37.9548 8.08591 37.8347 8.25256 37.9336L88.3909 85.4776H13.125C10.2255 85.4776 7.875 83.1271 7.875 80.2276Z"
          fill="#ECECEF"
          stroke="#B4B4C0"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M90.625 80.2276V38.1486C90.625 37.7611 90.2032 37.5208 89.8699 37.7186L8.94772 85.7276H85.125C88.1626 85.7276 90.625 83.2652 90.625 80.2276Z"
          fill="white"
          stroke="#9898A9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_325_331"
          x="0.822998"
          y="5.78174"
          width="96.345"
          height="81.6709"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0980392 0 0 0 0 0.129412 0 0 0 0 0.239216 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_325_331"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_325_331"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_325_331"
          x="31.4441"
          y="14.7012"
          width="35.9163"
          height="35.916"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.130086 0 0 0 0 0.136955 0 0 0 0 0.160995 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_325_331"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_325_331"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Mail;
